export enum RecruitEvents {
  NewTalentButtonClicked = 'recruit.talent.NewButtonClicked',
  PlusTalentButtonClicked = 'recruit.talent.PlusButtonClicked',
  TalentCreated = 'recruit.talent.Created',
  ReviewCreated = 'recruit.review.Created',
  ReviewViewed = 'recruit.review.Viewed',
  VacancyCreated = 'recruit.vacancy.Created',
  CompanyCreated = 'recruit.company.Created',
  ApplicationCreated = 'recruit.application.Created',
  SkillCreated = 'recruit.skill.Created'
}
